// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1PjYJ","label":"Labeled_label__IBkfr","divider":"Labeled_divider__iuAjt"};